/* import __COLOCATED_TEMPLATE__ from './track-handling-time.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type Conversation from 'embercom/objects/inbox/conversation';
import type ConversationHandlingService from 'embercom/services/conversation-handling-service';
import type Router from '@ember/routing/router-service';

interface Args {
  conversation: Conversation;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
}

export default class TrackHandlingTime extends Component<Signature> {
  @service declare conversationHandlingService: ConversationHandlingService;
  @service declare router: Router;

  private lastCheckedConversationId: number | null = null;

  get shouldHandleTracking(): boolean {
    return this.router.currentRouteName?.includes('inbox.workspace.inbox') ?? false;
  }

  @action
  trackConversationHandling() {
    this.conversationHandlingService.handleConversationSwitch(this.args.conversation);
    this.lastCheckedConversationId = this.args.conversation.id;
  }

  @action
  onConversationChange(_element: Element, [conversationId]: [number]) {
    if (this.lastCheckedConversationId === conversationId) {
      return;
    }
    this.trackConversationHandling();
  }

  @action
  onStateOrAssignmentChange() {
    this.conversationHandlingService.handleStateOrAssignmentChange(this.args.conversation);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Conversation::TrackHandlingTime': typeof TrackHandlingTime;
    'inbox2/conversation/track-handling-time': typeof TrackHandlingTime;
  }
}
